import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes';
import {AuthCheck, getStorageToken} from "@/mixins/Auth";
import {setAuthInHeader} from "@/api/request";
import DailyCheckIn from "@/mixins/dailyCheckIn";
import AutoLoginCheckIn from "@/mixins/autoLoginCheckIn";
import store from "@/store";


const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes : routes,
})

let isInitialRouteEnter = true;

const ensureLiveChannelDisplay = (force = false) => Promise.all([
    store.dispatch('common/ensureLiveChannelDisplay', {platform: 'WEB', force}),
    store.dispatch('common/ensureLiveChannelDisplay', {platform: 'WEBOS', force}),
]);

const syncLiveChannelDisplayOnRoute = async () => {
    const token = getStorageToken();
    if (!token) {
        return;
    }

    if (isInitialRouteEnter) {
        isInitialRouteEnter = false;
        await ensureLiveChannelDisplay(true);
        return;
    }

    await ensureLiveChannelDisplay(false);
};

router.beforeEach(async function (to, from, next) { // 토큰이 로컬스토리지에 담겼을 시 사용
    // to: 이동할 url에 해당하는 라우팅 객체
    if (to.matched.some(function (routeInfo) {
        return routeInfo.meta.authRequired;
    })) {
        let status = AuthCheck();
        if (status == 1) {
            let token = getStorageToken();
            setAuthInHeader(token);
            await syncLiveChannelDisplayOnRoute();
            let AutoLoginCheckInClass = new AutoLoginCheckIn();
            AutoLoginCheckInClass.autoLoginCheckIn();
            next(); // 페이지 전환
        } else {
            //toke 삭제
            let query = {redirect: to.fullPath};
            if(to.query.hasOwnProperty('_branch_match_id')) {
                let _branch_match_id = to.query._branch_match_id;
                let _branch_referrer = to.query._branch_referrer;
                query.redirect = to.path;
                query._branch_match_id = _branch_match_id;
                query._branch_referrer = _branch_referrer;
            }
            next({
                path: '/onboard',
                query: query
            })
        }
    } else {
        await syncLiveChannelDisplayOnRoute();
        next(); // 페이지 전환
    };
});

export default router;
